// AssetTimerView.js
import $ from 'jquery';

import AssetBaseView from 'advanced-inputs/AssetBaseView';
import template from 'advanced-inputs/control_timer.ejs';
import constants from "../../constants/Constants";
import listService from "../../service/ListService";

//=====================================================================
//
// An instance of this view represents a Timer Asset control.
//
// Brad Trebilcock, February 22, 2016
//
//=====================================================================
class AssetTimerView extends AssetBaseView  {

    initialize( opts ) {
        super.initialize( opts );
        this.template = template;
        return this;
    }

    render() {
        // PF-1155 Removing the cleanup of control so the timers can be stacked while they are being added.
        //this.$el.empty();
        const $id = $('#' + this.model.attributes.id);
        if  ( $id.length ) {
            $id.replaceWith(this.template(this.model.toJSON()));
        } else {
            //Applying same approach as used inside render of BaseControlView, for assets was working fine first time when dropped  control
            //but when switch between behaviors and desktop (timer and sound) where not rendered
            // Note: Don't use this.$el. Desktop could have been closed and rebuilt while control held in listService.
            $(constants.PAGE_ASSETS_ID).append(this.template(this.model.toJSON()));
        }
    }
}

export default AssetTimerView;
